export default {"src":"/_next/static/media/icon-chat-with-text.a64fc380.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};